// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__p8Dj7","left":"styles_left__2CdUG"};